module.exports = __webpack_public_path__ + "img/task-vip.d8a45fa6.png";